import { Modal } from "@smart/itops-sb-design-system-dom";

type LeaveWithoutPublishingModalProps = {
  open: boolean;
  loading?: boolean;
  onLeave: () => void;
  onPublish: () => void;
};

export const LeaveWithoutPublishingModal = ({
  open,
  loading,
  onLeave,
  onPublish,
}: LeaveWithoutPublishingModalProps) => (
  <Modal
    dataTestId="leave-without-publishing-modal"
    header={{ text: "Leave without publishing?" }}
    open={open}
    loading={loading}
    footer={{
      buttons: [
        {
          text: "Leave without publishing",
          type: "button",
          variant: "secondarySubtle",
          disabled: loading,
          onClick: onLeave,
        },
        {
          text: "Publish and continue",
          type: "button",
          variant: "primaryDefault",
          disabled: loading,
          onClick: onPublish,
        },
      ],
    }}
  >
    <p>
      Your form is saved. Recipients will keep using the last published version
      until you publish again.
    </p>
  </Modal>
);
